import React, { useEffect } from 'react';

export default function Header({ logoSrc, phone }) {
  useEffect(() => {
    const ROOT_ID = 'fe-booking-root-0e86b0b85021';
    const STYLE_ID = 'fe-booking-style-0e86b0b85021';
    const OVERLAY_ID = 'fe-booking-overlay-0e86b0b85021';
    const BOOKING_URL = 'https://appointments.fieldedge.com/book/bryant';
    const INSTANCE_KEY = '__fieldedgeBookingEmbed_0e86b0b85021';

    if (window[INSTANCE_KEY]) return;
    window[INSTANCE_KEY] = true;

    const root = document.getElementById(ROOT_ID);
    if (!root) return;

    if (!document.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent =
        '.fe-booking-overlay{position:fixed;inset:0;background:rgba(17,24,39,0.65);display:none;align-items:center;justify-content:center;z-index:999999;}' +
        '.fe-booking-modal{position:relative;width:min(960px,92vw);height:88vh;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 24px 64px rgba(0,0,0,0.25);}' +
        '.fe-booking-close{position:absolute;top:6px;right:10px;border:0;background:transparent;color:#6b7280;font:400 28px/1 Arial,sans-serif;cursor:pointer;z-index:2;padding:0;}' +
        '.fe-booking-close:hover{color:#111827;}' +
        '.fe-booking-frame{width:100%;height:100%;border:0;display:block;}';

      document.head.appendChild(style);
    }

    const triggerLink = document.createElement('a');
    triggerLink.href = BOOKING_URL;
    triggerLink.textContent =
      root.getAttribute('data-booking-text') || 'Book Now';

    // Match your existing button styles
    triggerLink.className =
      'button--secondary flex justify-center items-center w-full font-bold text-[22px] uppercase px-8 py-3 laptop:px-12 laptop:inline-block laptop:w-auto laptop:rounded-lg';

    let overlay = document.getElementById(OVERLAY_ID);

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = OVERLAY_ID;
      overlay.className = 'fe-booking-overlay';

      overlay.innerHTML = `
        <div class="fe-booking-modal" role="dialog" aria-modal="true">
          <button type="button" class="fe-booking-close">&times;</button>
          <iframe
            class="fe-booking-frame"
            src="${BOOKING_URL}"
            title="Book service"
            loading="lazy"
          ></iframe>
        </div>
      `;

      document.body.appendChild(overlay);
    }

    const openModal = () => {
      overlay.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    };

    triggerLink.addEventListener('click', e => {
      e.preventDefault();
      openModal();
    });

    overlay
      .querySelector('.fe-booking-close')
      ?.addEventListener('click', closeModal);

    root.appendChild(triggerLink);

    return () => {
      root.innerHTML = '';
    };
  }, []);

  return (
    <header className="bg-white sticky top-0 z-10 shadow-[0_0_20px_0_rgba(0,0,0,.7)]">
      <div className="mx-auto flex flex-wrap laptop:items-center laptop:container">
        <div className="flex-none rounded-md w-full laptop:w-auto laptop:flex-1">
          <img
            className="py-6 mx-auto laptop:mx-0 max-h-44"
            alt="logo"
            src={logoSrc}
          />
        </div>

        <div className="flex-none flex w-full phablet:flex-1 phablet:w-auto laptop:justify-end laptop:items-center">
          <div
            id="fe-booking-root-0e86b0b85021"
            data-booking-text="Schedule Now"
          />
        </div>

        <div className="flex-1 flex items-center laptop:flex-initial laptop:justify-end">
          <a
            href={`tel:${phone}`}
            className="button--primary flex justify-center flex-col items-center w-full font-semibold text-[22px] px-8 py-3 laptop:px-12 laptop:inline-block laptop:ml-7 laptop:rounded-lg laptop:w-auto"
          >
            <span className="hidden laptop:inline">Call Now!</span>
            <span className="font-bold">{phone}</span>
          </a>
        </div>
      </div>
    </header>
  );
}